import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from './EmblaCarouselArrowButtons';

const cards = (): void => {
  const selectors = {
    cardsSection: '[data-cards]',
    cardsCarouselViewport: '[data-cards-carousel-viewport]',
    cardsCarouselPrev: '[data-cards-carousel-prev]',
    cardsCarouselNext: '[data-cards-carousel-next]',
  };

  const cardsSections = document.querySelectorAll(selectors.cardsSection);

  cardsSections.forEach((section) => {
    const viewportNode: any =
      section.querySelector(selectors.cardsCarouselViewport) || '';
    const prevBtnNode: any = section.querySelector(selectors.cardsCarouselPrev);
    const nextBtnNode: any = section.querySelector(selectors.cardsCarouselNext);

    const options: EmblaOptionsType = {
      loop: false,
      align: 'start',
    };

    const embla = EmblaCarousel(viewportNode, options);

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
      embla,
      prevBtnNode,
      nextBtnNode
    );
  });
};

export default cards;
